export default __webpack_public_path__ + "static/media/D5E.2d11658f.jpeg";